import UsageProgress from "../../UsageProgress";
import FolderNavigationList from "../../folders/FolderNavigationList";

const FolderListingSidebar = props => {
    return <>
        <UsageProgress />
        <FolderNavigationList />
    </>
};

export default FolderListingSidebar;
